import {useApolloClient, ApolloClient} from "@apollo/client";
import {HookClass} from "@dvrt/graphql-widgets";
import {MutableRefObject, useEffect, useRef, useState} from "react";
import {createInitialData} from "@/components/private-routing-destination/initialData";
import {
    DestinationQuery,
    DestinationQueryVariables,
    DestinationDocument,
} from "@/components/private-routing-destination/queries.generated";

export type Data = {
    destinations: DestinationQuery;
};

const initialData: Data = {
    destinations: null,
};

export default class DataSource extends HookClass {
    protected client!: ApolloClient<object>;
    protected setLoaded!: (value: boolean) => void;

    public data!: MutableRefObject<Data>;
    public loaded!: boolean;

    useHooks() {
        [this.loaded, this.setLoaded] = useState<boolean>(false);
        this.client = useApolloClient();
        this.data = useRef<Data>(initialData);

        useEffect(() => {
            this.fetch();
        }, []);
    }

    get initialData() {
        return createInitialData(this.data.current.destinations);
    }

    async fetch() {
        this.setLoaded(false);

        const query = await this.client.query<DestinationQuery, DestinationQueryVariables>({
            query: DestinationDocument,
            fetchPolicy: "no-cache",
        });

        this.data.current.destinations = query.data;

        this.setLoaded(true);
    }
}
